import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UsersFilter, UsersSortType } from '../interfaces/user-list.interfaces';
import { Environment, ENVIRONMENT } from '../../../core/auth/auth.tokens';
import { CommunityUser, PaginatedResult, UserInfo } from 'libs/domain';
import { ExistsUser, GrantAccessUser, UserGrantResponse } from 'apps/web/src/app/domain/user/user.interface';
@Injectable({
  providedIn: 'root',
})
export class UserService {
  private options: Environment = inject(ENVIRONMENT);
  private baseUrlData: string;
  private baseUrlAuth: string;

  constructor(private http: HttpClient) {
    this.baseUrlData = `${this.options.baseUrl.data}`;
    this.baseUrlAuth = `${this.options.baseUrl.auth}`;
  }


  getUsersPage(tenantId: string, page: Number, size: Number, filter: UsersFilter): Observable<PaginatedResult<CommunityUser>> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())


    if (filter.searchTerm != undefined && filter.searchTerm !== null && filter.searchTerm !== '') params = params.set('search_term', filter.searchTerm);
    const dir = filter?.sortDirection;
    if (filter?.sortBy && (dir === UsersSortType.ASCENDING || dir === UsersSortType.DESCENDING)) {
      params = params.set('sort_by', filter.sortBy);
      params = params.set('sort_direction', dir);
    }

    return this.http.get<PaginatedResult<CommunityUser>>(`${this.baseUrlData}/communities/${tenantId}/users`, { params: params });
  }

  getUser(tenantId: string, userId: number): Observable<CommunityUser> {
    return this.http.get<CommunityUser>(this.baseUrlData + `/communities/${tenantId}/users/${userId}`);
    
  }

  updateUser(tenantId: String, userId: number, user: CommunityUser): Observable<UserInfo>{
    const url = `${this.baseUrlAuth}/users/${tenantId}/${userId}`;
    return this.http.post<UserInfo>(url, user);
  }
  
  grantAccess(grantAccessUser: GrantAccessUser, tenantUserId: number){
    const url = `${this.baseUrlAuth}/users/${tenantUserId}/access/grant`;
    return this.http.post<UserGrantResponse>(url, grantAccessUser);
  }
  
  revokeAccess(tenantUserId: number, tenantId: string){
    const url = `${this.baseUrlAuth}/users/${tenantUserId}/access/revoke`;
    let params = new HttpParams().set('tenant_id', tenantId);
    return this.http.post<UserGrantResponse>(url, null, { params });
  }

  globalUserExists(email: string){
    const baseUrl = `${this.baseUrlAuth}/users/exists`;
    
    let params = new HttpParams()
    params = params.append("email", email);
    
    return this.http.get<ExistsUser>(baseUrl, {params})
  }

  resendActivationLink(email: string, tenantId: string){
    const url = `${this.baseUrlAuth}/auth/resend-activation`;
    return this.http.post<string>(url, {"email":email,"tenantId":tenantId});
  }
}